// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__18f9f","upload":"Small_upload___fsyy","imageWrap":"Small_imageWrap__38dRv","removeBtn":"Small_removeBtn__Opzey"};